export default {
    //domain: 'http://agentapi.veraplussoft.co.th',
    //baseURL: 'http://agentapi.veraplussoft.co.th/api'
    domain: 'https://rentalagentcloud.com',
    baseURL: 'https://stg-api.rentalagentcloud.com/api'
}